package com.wintermar.inspection.core.ui.component.image.util

import io.github.vinceglb.filekit.PlatformFile

data class FileModel(
    val id: String = "",
    val name: String = "",
    val originalName: String = "",
    val path: String = "",
    val thumbnailPath: String = "",
    val size: Long = 0,
    val type: String = "",
    val uploadStatus: FileUploadStatus = FileUploadStatus.NONE,
    val currentUpload: FileChunkModel? = null,
    val blob: ByteArray? = null,
    val platformFile: PlatformFile? = null,
    val hasGenerateChunk: Boolean = false,
    val chunkFiles: List<FileChunkModel> = emptyList()
) {
    //generated when declare byte array
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as FileModel

        if (size != other.size) return false
        if (id != other.id) return false
        if (name != other.name) return false
        if (originalName != other.originalName) return false
        if (path != other.path) return false
        if (thumbnailPath != other.thumbnailPath) return false
        if (type != other.type) return false
        if (uploadStatus != other.uploadStatus) return false
        if (currentUpload != other.currentUpload) return false
        if (!blob.contentEquals(other.blob)) return false
        if (platformFile != other.platformFile) return false
        if (hasGenerateChunk != other.hasGenerateChunk) return false
        if (chunkFiles != other.chunkFiles) return false

        return true
    }

    //generated when declare byte array
    override fun hashCode(): Int {
        var result = size.hashCode()
        result = 31 * result + id.hashCode()
        result = 31 * result + name.hashCode()
        result = 31 * result + originalName.hashCode()
        result = 31 * result + path.hashCode()
        result = 31 * result + thumbnailPath.hashCode()
        result = 31 * result + type.hashCode()
        result = 31 * result + uploadStatus.hashCode()
        result = 31 * result + (currentUpload?.hashCode() ?: 0)
        result = 31 * result + (blob?.contentHashCode() ?: 0)
        result = 31 * result + (platformFile?.hashCode() ?: 0)
        result = 31 * result + hasGenerateChunk.hashCode()
        result = 31 * result + chunkFiles.hashCode()
        return result
    }

    fun acceptableToDelete(): Boolean {
        return !isUploading() || uploadStatus.name.isEmpty()
    }

    fun isUploading(): Boolean {
        return uploadStatus == FileUploadStatus.WAITING_TO_UPLOAD ||
                uploadStatus == FileUploadStatus.UPLOADING
    }
}
